import { Injectable } from '@angular/core';
import { OrderingOption } from 'generated/graphql-types';

@Injectable({ providedIn: 'root' })
export class DeviceSystemRegisterSessionStorageService {
   private readonly deviceOrderingOptionsStorageKey = '__ndt-system-device-ordering-options';

   clearAll(): void {
      localStorage.clear();
   }

   removeSystemDeviceOrderingOptions(): void {
      localStorage.removeItem(this.deviceOrderingOptionsStorageKey);
   }

   getSystemDeviceOrderingOptions() {
      const localData = localStorage.getItem(this.deviceOrderingOptionsStorageKey);
      if (localData) {
         return JSON.parse(localData);
      }
      return null;
   }

   setSystemDeviceOrderingOptions(orderingOptions: OrderingOption[] | null): void {
      localStorage.setItem(this.deviceOrderingOptionsStorageKey, JSON.stringify(orderingOptions));
   }
}
